export default {
    mounted() {
        // Add viewport change listener if supported
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.handleViewportResize);
        }

        // Add gesturestart event listener for Safari
        window.addEventListener('gesturestart', this.preventPinchZoom);
    },
    beforeDestroy() {
        // Remove viewport change listener if supported
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.handleViewportResize);
        }

        // Remove gesturestart event listener for Safari
        window.removeEventListener('gesturestart', this.preventPinchZoom);
    },
    methods: {
        handleViewportResize() {
            // Handle viewport changes here
            // For example, adjust your layout or trigger Vue methods/components
            console.log('Viewport resized');
        },
        preventPinchZoom(e) {
            // Prevent pinch-to-zoom on Safari
            e.preventDefault();
            console.log('Pinch-to-zoom gesture prevented');
        }
    }
};
